import React from "react";
import {
	Paper,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow,
	styled,
	TableCell,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import InvoiceLineItemRow from "./InvoiceLineItemRow";
import { receiveType as receiveTypes } from "../../util/receiveTypeMapping";
import { InvoiceLineItemTableProps } from "./types";

const useStyles = makeStyles(() => ({
	table: {
		minWidth: "300px",
	},
}));

const StyledTableCell = styled(TableCell)({
	padding: 0,
});

const InvoiceLineItemTable: React.FC<InvoiceLineItemTableProps> = ({
	invoiceLineItems,
	onEditClick,
	onRemoveClick,
	onHistoryClick,
	isDisableHistoryButton,
	isHardwareView,
	creditRequest,
	isEditable,
	isLocationBayEditable,
	onLocationNameChange,
	priorityStock,
	isArrivalsFeatureEnabled,
	isPriorityStockEnabled,
	receiveType,
	hideOverReceivedMessage,
	hideReceivedRemainEditColumns,
}) => {
	const classes = useStyles();

	return (
		<TableContainer component={Paper}>
			<Table size="small" className={classes.table} sx={{ tableLayout: 'fixed', width: '100%' }}>
				<TableHead>
					<TableRow>
						<StyledTableCell style={{ width: '40px' }} />
						<StyledTableCell>SKU</StyledTableCell>
						<StyledTableCell align="center">
							{receiveType === receiveTypes.transfer ? "Sent" : "Invoiced"}
						</StyledTableCell>
						{!hideReceivedRemainEditColumns && (
							<>
								<StyledTableCell align="center">Received</StyledTableCell>
								{creditRequest ? (
									<StyledTableCell align="center">Credited</StyledTableCell>
								) : (
									<StyledTableCell align="center">Remain</StyledTableCell>
								)}
								<StyledTableCell align="center">Edit</StyledTableCell>
							</>
						)}
					</TableRow>
				</TableHead>
				<TableBody>
					{invoiceLineItems.map((row) => {
						const priorityStockItem = priorityStock.find((ps) => ps.sku === row.sku);
						return (
							<InvoiceLineItemRow
								key={row.sku}
								invoiceLineItem={row}
								onEditClick={onEditClick}
								onRemoveClick={onRemoveClick}
								onHistoryClick={onHistoryClick}
								isDisableHistoryButton={isDisableHistoryButton}
								isHardwareView={isHardwareView}
								creditRequest={creditRequest}
								isEditable={isEditable}
								isLocationBayEditable={isLocationBayEditable}
								onLocationNameChange={onLocationNameChange}
								priorityFlag={priorityStockItem?.flag ?? ""}
								priorityReason={priorityStockItem?.reason ?? ""}
								isArrivalsFeatureEnabled={isArrivalsFeatureEnabled}
								isPriorityStockEnabled={isPriorityStockEnabled}
								hideOverReceivedMessage={hideOverReceivedMessage}
								hideReceivedRemainEditColumns={hideReceivedRemainEditColumns}
							/>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export const MemorizedInvoiceLineItemTable = React.memo(InvoiceLineItemTable);
